var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('v-app',{attrs:{"id":"app"}},[_c('Header'),_c('v-main',[_c('router-view')],1),_c('Footer')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-wrapper",attrs:{"id":"spinner-wrapper"}},[_c('img',{staticClass:"logo-loader",attrs:{"src":"/images/Logo-02.png","alt":""}}),_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"dot1"}),_c('div',{staticClass:"dot2"})])])
}]

export { render, staticRenderFns }